// extracted by mini-css-extract-plugin
export default {"gallery-item":"Gallery_gallery-item__7aD4u","fullscreen":"Gallery_fullscreen__i7ks0","normal":"Gallery_normal__tdWh4"};